<template>
  <div>
    <!-- Button to toggle the dialog -->
    <v-btn
      @click="$emit('toggleDialog')"
      variant="text"
      :disabled="!modelsCompareDetails"
      class="!tw-font-extralight tw-font-sans hover:tw-bg-[#D5DDEF] tw-w-32"
    >
      Compare
    </v-btn>

    <!-- Dialog for comparing models -->
    <v-dialog v-model="model" width="auto" persistent>
      <v-card>
        <div class="tw-p-2 tw-max-w-md sm:tw-min-w-[30px] tw-w-full">
          <!-- Title based on availability of comparison configurations -->
          <h2
            v-if="AllWDOptions.comparisonConfigurations?.length"
            class="tw-font-extralight tw-text-4xl tw-font-roboto tw-px-4 tw-mb-6"
          >
            Compare Trims
          </h2>
          <h2 v-else class="tw-font-extralight tw-text-3xl tw-font-roboto tw-px-4 tw-mb-6">
            No Trims Available To Compare
          </h2>

          <!-- List of comparison configurations -->
          <div
            class="tw-flex tw-justify-between tw-items-center tw-px-1 tw-h-8"
            v-for="(item, index) in AllWDOptions?.comparisonConfigurations"
            :key="index"
          >
            <v-checkbox
              class="custom-compare-checkbox tw-font-roboto tw-text-sm"
              :ripple="false"
              v-model="selectVariants"
              :label="`${item?.style?.styleName}`"
              :value="{ item, index }"
              color="primary"
            ></v-checkbox>
            <div class="tw-text-sm tw-font-r tw-px-4 tw-text-zinc-500 tw-mb-5">
              {{ item?.style?.baseMsrp }}
            </div>
          </div>
        </div>

        <!-- Console log for debugging -->
        {{ console.log(AllWDOptions) }}

        <!-- Dialog actions -->
        <template v-slot:actions>
          <v-btn
            v-if="AllWDOptions.comparisonConfigurations?.length"
            @click="cancelCompareVariants"
            class="tw-h-9 tw-w-24 tw-font-sans !tw-font-extralight !tw-bg-black !tw-text-white hover:!tw-bg-gray-200 hover:!tw-text-black"
            variant="tonal"
          >
            Cancel
          </v-btn>
          <v-btn
            v-if="!AllWDOptions.comparisonConfigurations?.length"
            @click="cancelCompareVariants"
            class="tw-h-9 tw-w-24 tw-font-sans !tw-font-extralight !tw-bg-black !tw-text-white hover:!tw-bg-gray-200 hover:!tw-text-black"
            variant="tonal"
          >
            OK
          </v-btn>
          <v-btn
            v-if="AllWDOptions.comparisonConfigurations?.length"
            @click="compareVariants"
            class="tw-h-9 tw-w-24 tw-font-sans !tw-font-extralight !tw-bg-black !tw-text-white hover:!tw-bg-gray-200 hover:!tw-text-black"
            variant="tonal"
          >
            Compare
          </v-btn>
        </template>
      </v-card>
    </v-dialog>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useVariablesStore } from '@/stores/useVariablesStore';
import { storeToRefs } from 'pinia';
import { useCarsStore } from '@/stores/useCarsStore';

const emit = defineEmits(['toggleDialog']);

const variablesStore = useVariablesStore();
const carStore = useCarsStore();

const { selectVariants } = storeToRefs(variablesStore);
const { modelsCompareDetails } = storeToRefs(carStore);

// Define reactive variables
const initiallySelectedVariants = ref([]);
const AllWDOptions = ref(modelsCompareDetails);
const model = defineModel();

// Function to handle comparison of variants
const compareVariants = () => {
  variablesStore.$patch({
    selectedForCompare: selectVariants.value,
  });
  initiallySelectedVariants.value = selectVariants.value;
  emit('toggleDialog');
};

// Function to handle cancellation of comparison
const cancelCompareVariants = () => {
  variablesStore.$patch({
    selectedForCompare: initiallySelectedVariants.value,
  });
  selectVariants.value = initiallySelectedVariants.value;
  emit('toggleDialog');
};
</script>

<style>
.custom-compare-checkbox .v-label {
  @apply !tw-text-sm;
}
</style>
